<template>
  <div>
    <b-modal id="authModal" ref="authModal" size="md" hide-footer class="homapt-auth-modal">
      <div slot="modal-header"></div>
      <div class="container">
        <div class="row">
          <div class="col-sm">
            <login-form v-on:hide-modal="hideAuthModal" ref="loginForm"></login-form>
            <div v-if="getLoginMode" class="sign-up">Don't have an account? <span class="text-link" v-on:click="updateLoginMode(false); $global.gaEvent('userLoginModalSignUpClick', 'navigation', 'User navigated to sign up instead of login')">Sign Up</span></div>
            <div v-if="!getLoginMode" class="sign-up">Already have an account? <span class="text-link" v-on:click="updateLoginMode(true); $global.gaEvent('userLoginModalLoginClick', 'navigation', 'User navigated to login instead of sign up')">Login</span></div>
            <div class="row row-padding">
              <div class="col-5 my-auto">
                <hr>
              </div>
              <div class="col-2 text-center my-auto">
                <h4 class="no-bottom-margin">Or</h4>
              </div>
              <div class="col-5 my-auto">
                <hr>
              </div>
            </div>
            <google-button></google-button>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card" id="businessCard">
              <div class="card-body">
                <div class="homapt-flex-wrapper">
                  <i class="fas fa-home"></i>
                  <h3 class="card-title">Realtor</h3>
                </div>
                <p class="card-text">Boost your brand and stay top of mind with Yarlow! With a Yarlow Realtor Subscription, clients can download the app featuring your branding. Now, every time homeowners track purchases or manage maintenance, they’ll think of you. It's a powerful, easy way to expand your reach, strengthen client connections, and keep your name front and center long after closing day.</p>
                <b-button variant="primary" to="/realtorsignup" v-on:click="hideAuthModal; $global.gaEvent('userLoginModalRealtorGetStartedClick', 'navigation', 'User used login modal to register as realtor')">Get Started</b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="card" id="businessCard">
              <div class="card-body">
                <div class="homapt-flex-wrapper">
                  <i class="fas fa-tools"></i>
                  <h3 class="card-title">Mortgage Lender</h3>
                </div>
                <p class="card-text">Stay top of mind and grow your brand with a Yarlow Mortgage Lender Subscription! With Yarlow, clients can download the app featuring YOUR branding. It’s a simple, powerful way to strengthen client relationships, expand your reach, and keep your name front and center for their future financing needs.</p>
                <b-button variant="primary" to="/lendersignup" v-on:click="hideAuthModal; $global.gaEvent('userLoginModalLenderGetStartedClick', 'navigation', 'User used login modal to register as mortgage lender')">Get Started</b-button>
              </div>
            </div>
          </div>
        </div>
        <!-- Removed service provider component  <div class="row">
          <div class="col">
            <div class="card" id="businessCard">
              <div class="card-body">
                <div class="homapt-flex-wrapper">
                  <i class="fas fa-tools"></i>
                  <h3 class="card-title">Service Provider</h3>
                </div>
                <p class="card-text">Yarlow helps homeowners find you and get connected, and then keeps you front and center for future work by marking you as their preferred professional.</p>
                <b-button variant="primary" to="/serviceprovidersignup" v-on:click="hideAuthModal; $global.gaEvent('userLoginModalServiceProviderGetStartedClick', 'navigation', 'User used login modal to register as service provider')">Get Started</b-button>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import GoogleButton from './GoogleButton.vue'
import LoginForm from './LoginForm.vue'

export default {
  components: {
    googleButton: GoogleButton,
    loginForm: LoginForm
  },
  computed: {
    ...mapGetters([
      'getSecretAccessKey',
      'getIdProvider'
    ]),
    ...mapGetters('loginModal', [
      'getLoginMode'
    ])
  },
  watch: {
    getIdProvider: function (newIdProvider, oldIdProvider) {
      if (newIdProvider && this.getSecretAccessKey) {
        this.hideAuthModal()
      }
    },
    getSecretAccessKey: function (newSecretAccessKey, oldSecretAccessKey) {
      if (newSecretAccessKey && this.getIdProvider) {
        this.hideAuthModal()
      }
    }
  },
  methods: {
    ...mapMutations('loginModal', [
      'updateLoginMode'
    ]),
    hideAuthModal () {
      this.$refs.loginForm.loginCleanUp()
      this.$refs.authModal.hide()
      this.$emit('logged-in')
    }
  }
}
</script>

<style scoped>
.homapt-modal-title {
  color: var(--text-color);
  cursor: pointer;
}

.homaptIsBlack {
  color: var(--title-color) !important;
}

.card {
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.fas {
  font-size: 56px;
  text-align: center;
  text-decoration: none;
}

.homapt-flex-wrapper {
  display: flex;
  padding-bottom: 2rem;
}

.card-title {
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 1rem
}

.close {
  text-shadow: none;
  opacity: 1;
}

.no-bottom-margin {
  margin-bottom: 0px;
}

.row-padding {
  padding-top: .7rem;
  padding-bottom: .7rem;
}

.sign-up {
  text-align: center;
  margin-top: 0.5rem;
}

.text-link {
  cursor: pointer;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/authentication/TheAuthModal.vue